import { Box, CircularProgress, Typography } from "@mui/material";

export const LoadingComponent = () => (
  <Box
    bgcolor={"background.default"}
    sx={{
      pt: 8,
      height: "100vh",
      display: "flex",
      alignItems: "center",
      flexDirection: "column"
    }}
  >
    <CircularProgress />
    <Typography variant="body1" sx={{ mt: 2, color: "text.secondary" }}>
      Loading...
    </Typography>
  </Box>
);
